export default __webpack_public_path__ + "static/media/H0002.864229a1.png";